// Menú organizado por ciclo de vida de la obra
export default [
  // === PLANEACIÓN ===
  {
    seccion: 'Planeación',
    items: [
      {
        ruta: 'planeacion',
        nombre: 'Obras',
        scopes: 'Planeación:ver',
        icono: 'mdi-clipboard-text-outline',
      },
      {
        ruta: 'presupuestos',
        nombre: 'Presupuestos',
        scopes: 'Presupuestos:ver',
        icono: 'mdi-calculator-variant-outline',
      },
    ],
  },
  // === PROGRAMACIÓN ===
  {
    seccion: 'Programación',
    items: [
      {
        ruta: 'solicitudesObras',
        nombre: 'Solic. de Autorización',
        scopes: 'Programación:ver',
        icono: 'mdi-file-document-check-outline',
      },
      {
        ruta: 'programacion',
        nombre: 'Oficios de Autorización',
        scopes: 'Programación:ver',
        icono: 'mdi-file-certificate-outline',
      },
      {
        ruta: 'obrasAutorizadasReporte',
        nombre: 'Obras Autorizadas',
        scopes: 'Programación:ver',
        icono: 'mdi-clipboard-check-outline',
      },
    ],
  },
  // === CONTRATACIÓN ===
  {
    seccion: 'Contratación',
    items: [
      {
        ruta: 'licitaciones',
        nombre: 'Licitaciones',
        scopes: 'Licitaciones:ver',
        icono: 'mdi-gavel',
      },
      {
        ruta: 'adjudicaciones',
        nombre: 'Adjudicaciones',
        scopes: 'Adjudicaciones:ver',
        icono: 'mdi-file-sign',
      },
      {
        ruta: 'contratos',
        nombre: 'Contratos',
        scopes: 'Contratos:ver',
        icono: 'mdi-file-document-edit-outline',
      },
    ],
  },
  // === EJECUCIÓN ===
  {
    seccion: 'Ejecución',
    items: [
      {
        ruta: 'ejecucion',
        nombre: 'Supervisión',
        scopes: 'Supervisión:ver',
        icono: 'mdi-hard-hat',
      },
      {
        ruta: 'estimaciones',
        nombre: 'Estimaciones',
        scopes: 'Estimaciones:ver',
        icono: 'mdi-file-chart-outline',
      },
    ],
  },
  // === PAGOS ===
  {
    seccion: 'Pagos',
    items: [
      {
        ruta: 'solicitudes',
        nombre: 'Solicitudes',
        scopes: 'Pagos:ver',
        icono: 'mdi-file-send-outline',
      },
      {
        ruta: 'pagos',
        nombre: 'Pagos',
        scopes: 'Pagos:ver',
        icono: 'mdi-credit-card-check-outline',
      },
    ],
  },
  // === CONTROL ===
  {
    seccion: 'Control',
    items: [
      {
        ruta: 'auditorias',
        nombre: 'Auditorías',
        scopes: 'Auditorias:ver',
        icono: 'mdi-clipboard-check-outline',
        children: [
          {
            ruta: 'auditorias',
            nombre: 'Registro',
            scopes: 'Auditorías:registro',
            icono: 'mdi-note-edit-outline',
          },
          {
            ruta: 'auditoriasSeguimiento',
            nombre: 'Seguimiento',
            scopes: 'Auditorías:seguimiento',
            icono: 'mdi-progress-check',
          },
        ],
      },
      {
        ruta: 'consultasEstatusContratos',
        nombre: 'Consultas',
        scopes: 'Consultas:ver',
        icono: 'mdi-file-search-outline',
      },
      {
        ruta: 'mapaObras',
        nombre: 'Mapa',
        scopes: '',
        icono: 'mdi-map-marker-radius-outline',
      },
      {
        ruta: 'tableroExpedientes',
        nombre: 'Tablero de Expedientes',
        scopes: 'TableroExpedientes:ver',
        icono: 'mdi-file-tree-outline',
      },
    ],
  },
  // === CONFIGURACIÓN (al final) ===
  {
    seccion: 'Sistema',
    items: [
      {
        ruta: 'configuracion',
        nombre: 'Configuración',
        scopes: 'Configuración:ver',
        icono: 'mdi-cog-outline',
      },
    ],
  },
];
